import { ICON_COLLECTION } from 'assets/media/icons';
import { AppAction } from 'common/enums';

export const APP_NAME = 'Growing Beyond Borders';
export const WELCOME_NOTE = 'Hi, Welcome to';
export const WELCOME_USER = 'Welcome to';
export const WELCOME_NOTE_DESCRIPTION =
    'The GBB portal is restricted to the GBB Admins users ONLY. The portal allows those with access to manage all the GBB versions data, including adding new, delete, archive data and much more.';
export const WELCOME_BUTTON = 'Get started';
export const REQUEST_BUTTON = 'Request Access';
export const REQUEST_ACCESS_DESCRIPTION =
    "Sorry! You don't have access to the platform. Please contact us at gbbsupport@ey.com for more details. Thank you!";
export const UPLOAD_SUCCESS_MESSAGE = 'File has been uploaded successfully';
export const REQUEST_ACCESS_PLACEHOLDER =
    'Please let us know why you require access to the platform...';
export const REQUEST_ACCESS_SUCCESS =
    'Your request has been sent to the admin. Our team will get in touch with you soon.';
export const DOWNLOAD_TEMPLATE_TEXT = 'Download template';

export const APP_MENU_OPTIONS = [
    {
        iconSrc: ICON_COLLECTION.IC_Logout,
        label: AppAction.Logout
    }
];

export const mailToSupport = `mailto:gbbsupport@ey.com`;
